import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutStaffingLevelsRequest } from '@/model/repository';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * 配置基準を取得
 */
export async function fetchStaffingLevels() {
  const fetchedStaffingLevels = await shiftServiceRepositories.staffingLevels.index();
  return fetchedStaffingLevels.data;
}

/**
 * 配置基準を保存
 */
export async function storeStaffingLevels(payload: PutStaffingLevelsRequest) {
  const fetchedStaffingLevels = await shiftServiceRepositories.staffingLevels.update(payload);
  return fetchedStaffingLevels.data;
}

export default {
  fetchStaffingLevels,
  storeStaffingLevels,
};
